document.addEventListener('alpine:init', () => {
  Alpine.data('videoHeroBackground', () => ({
    init() {
      this.$refs.iframe.src = `https://player.vimeo.com/video/${this.$refs.iframe.dataset.vimeoId}?autoplay=1&title=0&byline=0&portrait=0&muted=1&loop=1&controls=0&autopause=0`;
    },
  }));
});